// Script accordéon "voir plus"
$(document).on('click', '.chevrons', function(event) {
    var list = $(this).parents('.property-presentation__infos-pictos').find('ul');
    var chevrons = $(this);
    if(list.length) {
        var currentText = $(this).text();
        $(this).text(currentText == 'Voir plus' ? 'Voir moins' : 'Voir plus');
        
        chevrons.toggleClass('active');
        list.toggleClass('active');
    }
});